import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    redirect: '/app/my-resources'
  },
  {
    path: '/app',
    component: () => import('@/components/Layout'),
    children: [
      {
        path: '/app/my-resources',
        component: () => import('@/views/MyResources')
      },
      {
        path: '/app/resource-upload',
        component: () => import('@/views/ResourceUpload')
      },
      {
        path: '/app/profile',
        component: () => import('@/views/Profile')
      },
      {
        path: '/app/setting',
        component: () => import('@/views/Setting')
      },
      {
        path: '/app/manage',
        component: () => import('@/views/Manage')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
